import React,{useState,useEffect,useRef} from "react";
import {Link,useNavigate} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../../../core/img";
import {all_routes} from "../../../router/all_routes";
import Table from "../../../../core/dataTable/index";
import {Toaster} from 'react-hot-toast';
/* -- biz9 import start -- */
import {Log,Str,DateTime} from "biz9-utility"
import {Order_Logic} from "biz9-store"
import {User_Logic} from "biz9-user"
import {Data_Logic} from "biz9-data-app"
import {Field,Message,Title,Type,Url} from "../../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,Toast_Message,Template,Storage,System,User} from "../../../../project";
 import {Page_Logic,Portal_Type,Portal_Url,Portal_Title,Portal_Table,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Data} from "biz9-portal-app";
/* -- biz9 import end -- */
const Dashboard_User_Order = () => {
    const navigate = useNavigate();
    const timeoutRef = useRef(null);
    const [val_sub_page_title,setValSubPageTitle] = useState(Str.get_table_by_name(Portal_Table.ORDER,{plural:true}));
    const [val_search,setValSearch] = useState("");
    const [stop_search,setStopSearch] = useState('');
    const [orders,setOrders] = useState([]);
    const columns = [
    {
title: "Order #",
           dataIndex: "order_number",
           key: "order_number",
           render: (text: string, record: any) => (
                   <h2 className="table-avatar d-flex align-items-center">
                   <Link to={all_routes.dashboard_user_order_detail+"?order_number="+record.order_number} className="text-dark">
                   {record.order_number}
                   </Link>
                   </h2>
                   ),
           sorter: true
    },
 {
title: "Status",
       dataIndex: "status",
       key: "status",
       render: (text: string, record: any) => (
               <>
                {App.get_app_status_type_by_type(record.status_type).title}
                </>
               ),
       sorter: true
    },
 {
title: "Grand Total",
       dataIndex: "grand_total",
       key: "grand_total",
       render: (text: string, record: any) => (
               <>
                {Str.get_money(record.grand_total)}
                </>
               ),
       sorter: true
    },
 {
title: "Date & Time",
       dataIndex: "date_create",
       key: "date_create",
       render: (text: string, record: any) => (
               <>
                {DateTime.get_date(record.date_create) }{" "}
                {DateTime.get_time(record.date_create) }
                </>
               ),
        sorter: true
  },
 {
title: "Payment Plan",
       dataIndex: "payment_plan",
       key: "payment_plan",
       render: (text: string, record: any) => (
               <>
                {record.payment_plan_type}
                </>
               ),
       sorter: true
    },
   ];
   useEffect(() => {
        Toast_Message.loading(Message.LOADING);
        get_data();
        if(timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    },[]);
    async function get_data() {
        let search = Data_Logic.get_search(Portal_Table.ORDER,{user_id:User.get().id});
        let option = {};
	    let [response,data] = await Portal_Remote_Data.search(App.get_url(Portal_Url.DATA_SEARCH),search,option);
        Log.w('11_data',data);
        bind_items(data.items);
        Toast_Message.dismiss();
    };
    const post_search = (e) => {
        const value = e.target.value.trim();
        setValSearch(value);
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
                setStopSearch(value);
                let filter = {};
                if(value){
                    filter = {order_number:{ $regex:".*"+String(value),$options:"i"}}
                }
                let search = Data_Logic.get_search(Portal_Table.ORDER,filter);
                post_search_data(search);
        }, 500);
    };
    async function post_search_data(search) {
        /*
        let option = {get_user:true};
        let [response,data] = await Portal_Remote_Data.search(App.get_url(Portal_Url.DATA_SEARCH),search,option);
        setOrders(data.items);
        */
   }
    async function bind_items(data){
        setOrders(data);
     };
    return (
            <>
            <Toaster />
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="container px-0">
            {/*Inner Content */}
            <div className="content mx-4 mb-4">
            <div className="main-title my-4">
            <h4>{val_sub_page_title}</h4>
            </div>
            <div className="wallet-wrap">
            <div className="wallet-list">
            <div className="wallet-item mt-10">
            <div  className="pt-10">
            <input autoFocus type='text' autoComplete='off' className='form-control' placeholder={"Search"} value={val_search} onChange={post_search}/>
            </div>
            </div>
            </div>
            <div className="d-flex align-items-center" >
            <Link to="#" data-bs-toggle="modal" data-bs-target="#withdraw" hidden={true}className="btn btn-primary">
            Add
            </Link>
            </div>
            </div>
            <div className="table-filter pb-4">
           <Table  onUpdate={setOrders} allow_multiple={false} table={Portal_Table.ORDER} dataSource={orders} columns={columns} Selection={false} />
            </div>
            <div className="table-footer">
            <div id="tablepage" />
            </div>
            </div>
            {/* /Inner Content */}
    </div>
        </div>
        {/* /Page Content */}
        </>
        );
};
export default Dashboard_User_Order;
